export class VatUtils {
  static isEU(countryShort) {
    const euCountries =
      ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];
    return euCountries.includes(countryShort);
  }

  static showTVA(addressType, countryShort) {
    const isIndividual = (addressType === 'individual');
    const excludedCountries = ['CH', 'LI'];
    return !isIndividual && countryShort && !excludedCountries.includes(countryShort);
  }
}
